import ThemableLinkButton, {
    ThemableLinkButtonProps
} from '@tb-core/components/styled/links/themable-link-button';

const BrandedLinkButton = (props: ThemableLinkButtonProps) => (
    <ThemableLinkButton {...props} theme="brand" />
);

export default BrandedLinkButton;
